import React from 'react';
import { MdAdd } from 'react-icons/md';
import { Button } from '@aibuild/ui';
import {
  StateActions,
  StateBody,
  StateTitle,
  StateWrap,
} from './ProcessesStates.styled';

export interface ProcessesEmptyProps {
  /** True when the user is filtering / searching and the empty result is a
   *  consequence of those filters rather than there being zero processes. */
  hasActiveFilters: boolean;
  onCreate: () => void;
  onClearFilters: () => void;
  dataTestId?: string;
}

const ProcessesEmpty: React.FC<ProcessesEmptyProps> = ({
  hasActiveFilters,
  onCreate,
  onClearFilters,
  dataTestId = 'processes-empty',
}) => {
  if (hasActiveFilters) {
    return (
      <StateWrap data-testid={dataTestId}>
        <StateTitle>No processes match your filters</StateTitle>
        <StateBody>
          Try a different search term, or switch to a different status tab.
        </StateBody>
        <StateActions>
          <Button
            variant="outlined"
            onClick={onClearFilters}
            dataTestId={`${dataTestId}__clear`}
          >
            Clear filters
          </Button>
        </StateActions>
      </StateWrap>
    );
  }

  return (
    <StateWrap data-testid={dataTestId}>
      <StateTitle>No processes yet</StateTitle>
      <StateBody>
        Processes are reusable pipelines — wire up agents in a graph, run them
        as drafts to iterate, then publish for the team.
      </StateBody>
      <StateActions>
        <Button
          variant="filled"
          leadingIcon={<MdAdd size={18} />}
          onClick={onCreate}
          dataTestId={`${dataTestId}__create`}
        >
          Create your first process
        </Button>
      </StateActions>
    </StateWrap>
  );
};

export default ProcessesEmpty;
